import React from "react";
export default function Home() {
  return (
    <div style={{ textAlign: "center", fontSize: 16 }}>
      <h2>主应用</h2>
      {/* <div>
        主应用的内容
        <p style={{fontSize:"large",color:"orange"}}>想学习qiankun，请加入qiankun交流群，群里全是大佬</p>
        <img src={`${process.env.PUBLIC_URL}/1735133402754.jpg`} />
      </div> */}
      <div style={{ marginBottom: 8}}>欢迎访问qiankun演示案例</div>
      <span>前往访问wujie演示案例：</span>
      <a href="http://jiang-12-13.com:12122/" target="_blank" rel="noopener noreferrer">
        访问wujie
      </a>
      <div style={{ marginTop: 8 }}>
        <span>前往github获取案例源码：</span>
        <a
          href="https://github.com/Jiang-K-J/micro-app?tab=readme-ov-file"
          target="_blank" rel="noopener noreferrer"
        >
          获取源码
        </a>
        <span>（如果觉得有用，请帮忙点个<span style={{color:"orange"}}>小星星</span>）</span>
      </div>
    </div>
  );
}
